import { useMemo } from 'react';

import type { SubscriptionDetail } from '@rtkwlf/rendall';

import { useSubscriptions } from '@apis/rendall/queries/use-subscriptions';

export const useHasSubscription = (subscription: keyof SubscriptionDetail) => {
  const { data, isLoading, error } = useSubscriptions();
  const hasSubscription = useMemo(() => {
    if (data == null) {
      return null;
    }

    const subscriptionExists = data[subscription];

    return Boolean(subscriptionExists);
  }, [subscription, data]);

  return useMemo(
    () => ({ hasSubscription, isLoading, error }),
    [hasSubscription, isLoading, error],
  );
};
